<ng-container>
  <mbs-accordion
    #buildAccordion
    [activeIds]="activeIds"
    [align]="align"
    [narrowHeader]="true"
    [withoutBorder]="true"
    (panelChange)="onBuildPanelClick($event)">
    <mbs-accordion-panel [id]="panelId">
      <span
        *panelIconHeader
        [ngClass]="getIcon(build)"></span>
      <ng-container panelTitle>
        <span class="d-flex lh-1 mb-2 mr-4 pr-3 align-items-center">
          <span class="d-block text-md lh-1">{{ build.name }}</span>
          <span
            *ngIf="beta"
            class="text-cyan text-xs pl-2">
            {{ 'shared:beta' | i18next: { format: 'title' } }}
          </span>
          <span>
            <i
              aria-hidden="true"
              class="ml-2 fa"
              [class.fa-caret-down]="!buildAccordion.isExpanded(panelId)"
              [class.fa-caret-up]="buildAccordion.isExpanded(panelId)"></i>
          </span>
        </span>

        <span class="d-block lh-1 text-xs fw-normal mb-1">
          {{ getPublicVersionName(build) }}
        </span>
      </ng-container>

      <ng-container panelAppendHeader>
        <ng-container *ngIf="build?.public; else noPublicBuild">
          <div
            container="body"
            [ngbTooltip]="
              getDisabledByMinimalVersionSupportsCompany(build.public, build.mbsBuildType)
                ? ('shared:download-build.versionIsUnsupportedByCompany' | i18next)
                : ''
            ">
            <mbs-button
              type="primary"
              [attr.data-e2e]="elementSelectors.name[type || 'default']?.publicDownloadBtn"
              [disabled]="getDisabledByMinimalVersionSupportsCompany(build.public, build.mbsBuildType)"
              [loading]="downloadBuildInProgress?.notSandbox"
              (click)="onDownloadButtonClick(build, buildVersionType.Public)">
              {{ 'common.download' | i18next: { format: 'title' } }}
            </mbs-button>
          </div>

          <ng-container
            [ngTemplateOutlet]="dropdown"
            [ngTemplateOutletContext]="{ versionType: buildVersionType.Public, index: index }"></ng-container>
        </ng-container>

        <ng-template #noPublicBuild>
          <ng-container *ngIf="(PermissionsEnum.Rebranding | can: 'read') && (!isSandboxEnabled || !build?.sandbox)">
            <mbs-button
              type="secondary"
              [attr.data-e2e]="elementSelectors.name[type || 'default']?.noPublicGenerateBtn"
              [disabled]="isOneOfTheBuildsIsInProgress()"
              [loading]="isBuildInProgress(build)"
              (click)="generateBuild(build)">
              {{ 'shared:buttons.generate' | i18next: { format: 'title' } }}
            </mbs-button>
          </ng-container>
        </ng-template>
      </ng-container>

      <ng-container
        [ngTemplateOutlet]="buildDescription"
        [ngTemplateOutletContext]="{ build }"></ng-container>
    </mbs-accordion-panel>
  </mbs-accordion>
</ng-container>

<ng-container *ngIf="build.sandbox && isSandboxEnabled">
  <div
    class="mt-4 d-flex justify-content-between"
    [class.ml-3]="align !== 'left'">
    <div>
      <mbs-tag
        class="background-warning"
        [active]="true"
        [attr.data-e2e]="elementSelectors.name[type || 'default']?.sandboxTag"
        [noBorder]="true">
        {{ 'shared:download-build.versions.sandbox' | i18next: { format: 'title' } }}
      </mbs-tag>

      <span class="ml-2 mr-2">v{{ build.sandbox.version }}</span>
    </div>

    <div class="d-flex">
      <mbs-button
        *ngIf="PermissionsEnum.Rebranding | can: 'read'"
        [attr.data-e2e]="elementSelectors.name[type || 'default']?.makePublicSandbox"
        [disabled]="isOneOfTheBuildsIsInProgress()"
        [loading]="makePublicButtonLoadingId === build.mbsBuildType"
        (click)="makeBuildPublic(build)">
        {{ 'shared:download-build.versions.makePublic' | i18next: { format: 'title' } }}
      </mbs-button>

      <div
        container="body"
        [ngbTooltip]="
          getDisabledByMinimalVersionSupportsCompany(build.sandbox, build.mbsBuildType)
            ? ('shared:download-build.versionIsUnsupportedByCompany' | i18next)
            : ''
        ">
        <mbs-button
          class="ml-3"
          type="primary"
          [attr.data-e2e]="elementSelectors.name[type || 'default']?.downloadSandbox"
          [disabled]="getDisabledByMinimalVersionSupportsCompany(build.sandbox, build.mbsBuildType)"
          [loading]="downloadBuildInProgress?.sandbox"
          (click)="onDownloadButtonClick(build, buildVersionType.Sandbox)">
          {{ 'common.download' | i18next: { format: 'title' } }}
        </mbs-button>
      </div>

      <ng-container
        [ngTemplateOutlet]="dropdown"
        [ngTemplateOutletContext]="{ versionType: buildVersionType.Sandbox, index: index }"></ng-container>
    </div>
  </div>
</ng-container>

<ng-container
  [ngTemplateOutlet]="newBuildSection"
  [ngTemplateOutletContext]="{ section: getNewBuildSection(build), isSandbox: isSandboxEnabled }">
</ng-container>

<ng-container *ngIf="build.beta">
  <div
    class="mt-4 d-flex justify-content-between"
    [class.ml-3]="align !== 'left'">
    <div>
      <mbs-tag
        class="background-pink"
        [active]="true"
        [noBorder]="true">
        {{ 'shared:download-build.versions.beta' | i18next: { format: 'title' } }}
      </mbs-tag>

      <span class="ml-2 mr-2">v{{ build.beta.version }}</span>
    </div>

    <div class="d-flex">
      <mbs-button
        class="ml-3"
        type="primary"
        [attr.data-e2e]="elementSelectors.name[type || 'default']?.betaDownloadBtn"
        (click)="onDownloadButtonClick(build, buildVersionType.Beta)">
        {{ 'common.download' | i18next: { format: 'title' } }}
      </mbs-button>

      <ng-container
        [ngTemplateOutlet]="dropdown"
        [ngTemplateOutletContext]="{ versionType: buildVersionType.Beta, index: index }"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template
  #dropdown
  let-index="index"
  let-versionType="versionType">
  <div
    class="btn-group"
    container="body"
    ngbDropdown
    placement="auto"
    [ngbTooltip]="
      getDisabledByMinimalVersionSupportsCompany(build[versionType], build.mbsBuildType)
        ? ('shared:download-build.versionIsUnsupportedByCompany' | i18next)
        : ''
    ">
    <mbs-button
      #copyTooltip="ngbTooltip"
      class="-no-arrow ml-3"
      container="body"
      ngbDropdownToggle
      placement="left"
      triggers="manual"
      type="secondary"
      [attr.data-e2e]="elementSelectors.name[type || 'default']?.[getCopyDropdownE2eKey(versionType)]"
      [autoClose]="false"
      [disabled]="getDisabledByMinimalVersionSupportsCompany(build[versionType], build.mbsBuildType)"
      [ngbTooltip]="copyTooltipTemplate"
      [square]="true"
      [tooltipClass]="BUILD_ACTIONS_TRIGGER_BUTTON_TOKEN + versionType + index + ' -no-arrow'">
      <span class="ico ico-EllipsisV px-1"></span>
    </mbs-button>

    <ng-template #copyTooltipTemplate>
      <div class="row px-3 py-1">
        <span
          *ngIf="currentCopingStatus === copyingStatus.Copying"
          class="loader loader-primary mr-2"></span>
        <span class="text-md">{{ copyingTooltipText | async }}</span>
      </div>
    </ng-template>

    <div
      aria-labelledby="download-sidepanel-build-actions"
      ngbDropdownMenu>
      <button
        ngbDropdownItem
        [attr.data-e2e]="elementSelectors.name[type || 'default']?.[getCopyLinkE2eKey(versionType)]"
        (click)="onCopyDownloadLinkButtonClick(build, versionType)">
        {{ 'shared:buttons.copyLink' | i18next: { format: 'title' } }}
      </button>

      <button
        *ngIf="isBuildSupportCommand(build)"
        ngbDropdownItem
        [attr.data-e2e]="elementSelectors.name[type || 'default']?.[getCopyCommandE2eKey(versionType)]"
        (click)="onCopyCommandForDeployBuildClick(build, versionType)">
        {{ 'shared:download-build.copyInstallationScript' | i18next: { format: 'title' } }}
      </button>

      <button
        *ngIf="
          versionType !== buildVersionType.Beta &&
          (currentUser?.IsProvider ? showDeleteButton : (PermissionsEnum.Rebranding | can: 'read') && showDeleteButton)
        "
        ngbDropdownItem
        [attr.data-e2e]="elementSelectors.name[type || 'default']?.[versionType === buildVersionType.Sandbox ? 'sandBoxDelete' : 'delete']"
        (click)="onRemoveBuildButtonClick(build, versionType === buildVersionType.Sandbox, deleteConfirmTemplate)">
        {{ 'shared:download-build.deleteInstallationPackage' | i18next: { format: 'title' } }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template
  #deleteConfirmTemplate
  let-context>
  <p>
    {{
      'shared:download-build.deleteBuildModalTitle'
        | i18next
          : {
              buildName: context.build.name,
              buildType: (context.isSandbox ? 'shared:download-build.versions.sandbox' : 'shared:download-build.versions.public') | i18next
            }
    }}
  </p>
  <mbs-alert
    class="mb-0"
    [icon]="true"
    [type]="alertType.info">
    {{ 'shared:download-build.deleteBuildModalText' | i18next }}
  </mbs-alert>
</ng-template>

<ng-template
  #newBuildSection
  let-buildSection="section"
  let-isSandbox="isSandbox"
  [templateTyping]="newBuildSectionToken">
  <ng-container *ngIf="buildSection?.isNewerVersionAvailable">
    <div
      class="mt-4 d-flex justify-content-between"
      [class.ml-3]="align !== 'left'">
      <div>
        <mbs-tag
          [active]="true"
          [noBorder]="true">
          {{ 'common.new' | i18next: { format: 'title' } }}
        </mbs-tag>

        <span class="ml-2 mr-2">v{{ buildSection?.availableVersion }}</span>

        <ng-container *ngIf="showHelp">
          <a
            target="_blank"
            [href]="'/m0001' | helpLink">
            {{ 'shared:download-build.whatsNew' | i18next }}
            <i class="fa fa-external-link"></i>
          </a>
        </ng-container>
      </div>

      <ng-container *ngIf="PermissionsEnum.Rebranding | can: 'read'">
        <mbs-button
          [attr.data-e2e]="elementSelectors.name[type || 'default']?.[isSandbox ? 'bsGenerateSandbox' : 'bsGenerate']"
          [disabled]="isOneOfTheBuildsIsInProgress()"
          [loading]="isBuildInProgress(build)"
          (click)="generateBuild(build, isSandbox)">
          {{ (isSandbox ? 'shared:download-build.versions.generateSandbox' : 'shared:buttons.generate') | i18next: { format: 'title' } }}
        </mbs-button>
      </ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template
  #buildDescription
  let-build="build"
  [templateTyping]="buildDescriptionToken">
  <div class="pl-4">
    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.CommonWindowsBuild"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of windowsSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
      <p class="mt-1 mb-0">{{ 'shared:builds.windows.can_backup_description' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of windowsCanBackup"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.VMware"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of vmwareSupported"
          class="col-12">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.LinuxUbuntu14"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of linuxDebSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.LinuxRedHat6"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of linuxRpmSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.LinuxMac"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of macOsSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.RMMAgentExe || build.mbsBuildType === buildTypesEnum.RMMAgentMsi"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of rmmSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.RMMAgentMac"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of rmmMacSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.CBLRA"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of connectHostForWindowsSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.MacRA"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of connectHostForMacSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.RMMAgentLinuxRpm"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of rmmLinuxRpmSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.RMMAgentLinuxDeb"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of rmmLinuxDebSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.NetworkDiscovery"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of rmmSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>

    <div
      *ngIf="build.mbsBuildType === buildTypesEnum.MacArm"
      class="small text-start">
      <p class="mb-0">{{ 'shared:download-build.supported_os' | i18next }}:</p>
      <ul class="p-0 mb-0 form-row list-style-inside">
        <li
          *ngFor="let item of macArmSupported"
          class="col-auto">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</ng-template>
